var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.688 60.213a11.69 11.69 0 01-3.29-3.239c-.88-1.296-1.501-2.76-1.828-4.305a105.563 105.563 0 01-.442-41.287 11.8 11.8 0 011.729-4.277c1.752-2.647 4.443-4.458 7.49-5.042a105.625 105.625 0 0141.295-.05l-.005.011c1.527.296 2.987.894 4.303 1.762a11.732 11.732 0 013.286 3.244c.878 1.296 1.5 2.76 1.827 4.305a105.643 105.643 0 01.44 41.284 11.74 11.74 0 01-1.727 4.277c-1.755 2.647-4.448 4.458-7.497 5.042a105.65 105.65 0 01-41.288.045 11.92 11.92 0 01-4.293-1.77z",
    fill: "#C7C2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.16 24.84h-22a1 1 0 00-1 1v16a1 1 0 001 1h22a1 1 0 001-1v-16a1 1 0 00-1-1zM37.16 24.84v-2a2 2 0 00-2-2h-6a2 2 0 00-2 2v2",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.16 31.629a23.89 23.89 0 01-12 3.211 23.89 23.89 0 01-12-3.21M30.66 30.84h3",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconCase;